import React, { useEffect, useState,useCallback, useRef } from 'react';
import { useParams, useNavigate, useLocation  } from 'react-router-dom';
import { getDocById, processApprovalLine, replaceApprovalLines, addDocOpinion , replaceDocAuths } from '../../api/aprvDoc';
import { getCurrentUser } from '../../api/common'; 
import { formatDate, saveMap, lineTypeMap, publicTypeMap, approvalActionMap } from '../../utils/commonUtils';
import SubFormRouter from './subforms/SubFormRouter';
import AprvLineSelect from '../../components/OrgSelect/AprvLineSelect';
import OrgSelect from '../../components/OrgSelect/OrgSelect';
import '../../css/AprvDocForm.css';
import FileAttachment from '../../components/FileAttachment/FileAttachment';
import TodoRegisterLayer from '../../components/todo/TodoRegisterLayer';
import { TODO_REF_TYPE, TODO_REF_TABLE } from '../../api/todoApi';

function AprvDocView({onOpenOpinionModal, aprvId: propAprvId}) {
  const { aprvId: paramAprvId } = useParams();
  const aprvId = propAprvId || paramAprvId;
  const navigate = useNavigate();
  const [docData, setDocData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);

  const [showLinePopup, setShowLinePopup] = useState(false);
  const [showAuthPopup, setShowAuthPopup] = useState(false);
  const [showTodoLayer, setShowTodoLayer] = useState(false);

  const [approvalLines, setApprovalLines] = useState([]);
  const todoRegBtnRef = useRef(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get("page") || 1;
  const search = queryParams.get("search") || "";
  const status = queryParams.get("status") || "";

  const fetchDoc = useCallback(async () => {
    try {
      const token = sessionStorage.getItem('token');
      const user = await getCurrentUser(token);
      setCurrentUser(user);

      const data = await getDocById(aprvId, token);
      setDocData(data);
      console.log(user);
      console.log(data);
      if (data?.lines) {
        setApprovalLines(data.lines);
      }
    } catch (err) {
      setError('문서를 불러오는 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  }, [aprvId]); 

  useEffect(() => {
    fetchDoc();
  }, [fetchDoc]);


  if (loading) return <div className="p-4">⏳ 문서 불러오는 중...</div>;
  if (error) return <div className="p-4 text-danger">❌ {error}</div>;
  if (!docData) return <div className="p-4">문서 데이터가 없습니다.</div>;

  const { doc, subForms, lines, files, auths } = docData;


  const currentLine = currentUser && lines.find(
      (line) => line.current_yn === 'y' && line.user_id === currentUser.userid
  );

  const handleApprovalAction = async (action, opinion) => {
    const updatedLines = [...lines];
    const now = new Date().toISOString();

    const currentIdx = updatedLines.findIndex(
      (line) => line.current_yn === "y" && line.user_id === currentUser.userid
    );
    if (currentIdx === -1) return;

    updatedLines[currentIdx] = {
      ...updatedLines[currentIdx],
      line_status: approvalActionMap[action] || "대기",
      done_date: now,
      read_date: now,
      current_yn: "n",
    };

    let updatedDoc = { ...doc };
    if (action === "reject") {
      updatedDoc = { ...updatedDoc, doc_status: "reject", completed_date: now };
    } else {
      const nextIdx = updatedLines.findIndex(
        (line) => line.line_no === updatedLines[currentIdx].line_no + 1
      );
      if (nextIdx !== -1) {
        updatedLines[nextIdx] = { ...updatedLines[nextIdx], current_yn: "y" };
      } else {
        updatedDoc = { ...updatedDoc, doc_status: "complete", completed_date: now };
      }
    }

    setDocData({ ...docData, doc: updatedDoc, lines: updatedLines });

    try {
      const token = sessionStorage.getItem("token");

      // ✅ 1. 결재 처리 API 호출 (opinion 제거)
      await processApprovalLine(
        doc.aprv_id,
        updatedLines[currentIdx].line_id,
        action,
        token
      );

      // ✅ 2. 결재 의견 등록 API 호출
      if (opinion.trim()) {
        await addDocOpinion(
          doc.aprv_id,
          {
            opinion: opinion,
            user_id: currentUser.userid,
            user_name: currentUser.name,
            user_position: currentUser.position,
            user_dept_code: currentUser.dept_code,
            user_dept_name: currentUser.dept_name,
          },
          token
        );
      }

      alert("결재 처리가 완료되었습니다.");
      await fetchDoc();
    } catch (err) {
      console.error("결재 처리 실패:", err);
      alert("결재 처리 중 오류가 발생했습니다.");
    }
  };

  const handleConfirmLineSelection = async (selectedTargets) => {
    setShowLinePopup(false);

    try {
      const token = sessionStorage.getItem('token');

      // 결재/합의/담당/수신은 결재라인 테이블로, 열람(lr)은 권한 테이블로 분리 저장
      const approverTargets = selectedTargets.filter(line => line.line_type !== 'lr');
      const readerTargets = selectedTargets.filter(line => line.line_type === 'lr');

      const authPayload = readerTargets.map((t) => {
        const inferredTargetType = t.target_type || (
          String(t.user_id) === String(t.user_dept_code) && !t.user_position ? 'dept' : 'user'
        );
        return {
          target_type: inferredTargetType,
          target_id: t.target_id || t.user_id,
          target_name: t.target_name || t.user_name,
          target_from: 'doc',
          target_auth: 'read',
        };
      });

      await replaceApprovalLines(
        doc.aprv_id,
        approvalLines,
        approverTargets,
        token
      );

      await replaceDocAuths(doc.aprv_id, authPayload, token);

      await fetchDoc();

      alert("결재선이 변경되었습니다.");
    } catch (err) {
      console.error('결재선 변경 실패:', err);
      alert('결재선 변경 중 오류가 발생했습니다.');
    }
  };

  const handleConfirmAuthSelection = async (selectedTargets) => {
    setShowAuthPopup(false);
    try {
      const token = sessionStorage.getItem("token");

      // ✅ replaceAuths 호출
      const payload = selectedTargets.map(t => ({
        target_type: t.target_type,
        target_id: t.target_id,
        target_name: t.target_name,
        target_from: "doc",
        target_auth: "read",
      }));

      await replaceDocAuths(doc.aprv_id, payload, token);

      alert("열람자가 수정되었습니다.");
      await fetchDoc();
    } catch (err) {
      console.error("열람자 수정 실패:", err);
      alert("열람자 수정 중 오류가 발생했습니다.");
    }
  };


  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-header bg-primary text-white">
          <h5 className="mb-0">📑 {doc.form_name}</h5>
        </div>
        <div className="card-body">
          <div className="table-responsive mt-2 d-flex justify-content-end">
            <table
              className="table table-bordered text-center align-middle"
              style={{ width: `${(lines.length + 1) * 10}%` }}
            >
              <tbody>
                <tr className="approval-line-header">
                  <td>기안</td>
                  {lines.map(line => (
                    <td key={line.line_id}>
                      {lineTypeMap[line.line_type] || line.line_type}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>{doc.user_name} / {doc.user_position}</td>
                  {lines.map(line => (
                    <td key={line.line_id}>
                      {line.user_name} / {line.user_position}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>상신</td>
                  {lines.map(line => (
                    <td key={line.line_id}>
                      {line.line_status}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td>{formatDate(doc.req_date)}</td>
                  {lines.map(line => (
                    <td key={line.line_id}>
                      {line.done_date ? formatDate(line.done_date) : ''}
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>

          <table className="table table-bordered">
            <tbody>
              {auths && auths.length > 0 && (
              <tr className="table-four-cols">
                <td>열람</td>
                <td colSpan="3">
                  {auths.map(a => a.target_name).join(", ")}
                </td>
              </tr>
              )}

              <tr className="table-four-cols">
                <td>기안자</td>
                <td>{doc.user_name} / {doc.user_position}</td>
                <td>기안부서</td>
                <td>{doc.user_dept_name}</td>
              </tr>
              <tr className="table-four-cols">
                <td>문서 번호</td>
                <td><span>{doc.doc_no}</span></td>
                <td>공개 범위</td>
                <td>{publicTypeMap[doc.public_type] || doc.public_type}</td>
              </tr>
              <tr className="table-four-cols">
                <td>기안일</td>
                <td><span>{formatDate(doc.req_date)}</span></td>
                <td>보존연한</td>
                <td><span>{saveMap[String(doc.doc_save)] || ''}</span></td>
              </tr>
              <tr className="table-title">
                <td>제목</td>
                <td colSpan="3"><span>{doc.title}</span></td>
              </tr>
            </tbody>
          </table>

          {subForms && subForms.length > 0 ? (
            subForms.map((sf) => {
              const parsed = JSON.parse(JSON.parse(sf.json_data));
              const formValues = parsed[sf.sub_form_code] || {};

              return (
                <div key={sf.id} className="mb-3">
                  <div className="mt-2">
                    <SubFormRouter
                      subFormCode={sf.sub_form_code}
                      formData={{
                        ...formValues,
                        editorContent: sf.html_data || '',
                      }}
                      setFormData={() => {}}
                      mode="view"
                      docTitle={doc.title}
                    />
                  </div>
                </div>
              );
            })
          ) : (
            <p>하위양식 없음</p>
          )}
          {/* ✅ 첨부파일 */}
          {files && files.length > 0 && (
            <div className="mb-4">
              <h6 className="fw-bold mb-2">첨부파일</h6>
              <FileAttachment
                files={files}
                mode="view"
                enableAi={true}
                fileTextApiBase="/api/aprv/file"
              />
            </div>
          )}
          <div className="d-flex justify-content-between mt-3">
            <div style={{ position: 'relative' }}>
              <button
                ref={todoRegBtnRef}
                type="button"
                className="btn btn-outline-success"
                onClick={() => setShowTodoLayer((prev) => !prev)}
              >
                To-Do 등록
              </button>
              {showTodoLayer && (
                <TodoRegisterLayer
                  direction="up"
                  source={{
                    ref_type: TODO_REF_TYPE.APPROVAL,
                    ref_table: TODO_REF_TABLE.APPROVAL,
                    ref_id: doc.aprv_id,
                    title: doc.title,
                  }}
                  anchorRef={todoRegBtnRef}
                  onClose={() => setShowTodoLayer(false)}

                />
              )}
            </div>

            <div className="d-flex justify-content-end">
            {doc.doc_status === "draft" && (
              <button
                className="btn btn-warning me-2"
                onClick={() => navigate(`/aprvdoc/edit/${doc.aprv_id}?page=${page}&search=${search}${status ? `&status=${status}` : ''}`)}
              >편집</button>

            )}
            {doc.doc_status === "request" && (
              <>
                {currentLine && currentLine.line_type === 'lb' && (
                  <>
                    <button className="btn btn-success me-2" onClick={() => onOpenOpinionModal("approve", handleApprovalAction)}>승인</button>
                    <button className="btn btn-danger me-2" onClick={() => onOpenOpinionModal("reject", handleApprovalAction)}> 반려</button>
                  </>
                )}
                {currentLine && currentLine.line_type === 'lc' && (
                  <>
                    <button className="btn btn-success me-2" onClick={() => onOpenOpinionModal("agree", handleApprovalAction)}>찬성</button>
                    <button className="btn btn-danger me-2" onClick={() => onOpenOpinionModal("disagree", handleApprovalAction)}>반대</button>
                  </>
                )}
                {currentLine && (
                  <button className="btn btn-warning me-2" onClick={() => setShowLinePopup(true)}>결재선변경</button>
                )}
              </>
            )}
            {doc.doc_status === "complete" &&
              (doc.user_id === currentUser?.userid || currentUser?.role === "admin") && (
                <button
                  className="btn btn-info me-2"
                  onClick={() => setShowAuthPopup(true)}
                >
                  열람자 등록
                </button>
            )}
            {/* ✅ 목록으로 버튼은 항상 표시 */}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => navigate(`/aprvdoc?page=${page}&search=${search}${status ? `&status=${status}` : ''}`)}
            >
              목록으로
            </button>
            </div>

          </div>
          {/* 결재 의견 표시 */}
          {docData.opinions && docData.opinions.length > 0 && (
            <div className="mt-4">
              <h5>📝 결재 의견</h5>
              <table className="table table-bordered">
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "15%" }}>작성자</th>
                    <th style={{ width: "15%" }}>부서</th>
                    <th style={{ width: "15%" }}>직책</th>
                    <th style={{ width: "40%" }}>의견</th>
                    <th style={{ width: "15%" }}>작성일시</th>
                  </tr>
                </thead>
                <tbody>
                  {docData.opinions.map((op) => (
                    <tr key={op.id}>
                      <td>{op.user_name}</td>
                      <td>{op.user_dept_name}</td>
                      <td>{op.user_position || "-"}</td>
                      <td style={{ whiteSpace: "pre-wrap" }}>{op.opinion}</td>
                      <td>{new Date(op.create_date).toLocaleString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {showLinePopup && (
        <AprvLineSelect
          writer={{
            user_id: doc.user_id,
            user_name: doc.user_name,
            user_position: doc.user_position,
            user_dept_code: doc.user_dept_code,
            user_dept_name: doc.user_dept_name,
          }}
          initialSelected={[
            ...approvalLines,
            ...(auths || []).map((a, idx) => ({
              line_type: 'lr',
              line_no: approvalLines.length + idx + 1,
              current_yn: 'n',
              line_status: '열람',
              user_id: a.target_id,
              user_name: a.target_name,
              user_position: a.target_type === 'dept' ? null : '-',
              user_dept_code: a.target_type === 'dept' ? a.target_id : (a.user_dept_code || ''),
              user_dept_name: a.target_type === 'dept' ? a.target_name : (a.user_dept_name || ''),
              target_type: a.target_type,
              target_id: a.target_id,
              target_name: a.target_name,
            })),
          ]}
          docStatus={doc?.doc_status}
          onCancel={() => setShowLinePopup(false)}
          onConfirm={handleConfirmLineSelection}
        />
      )}
      {showAuthPopup && (
        <OrgSelect
          onConfirm={handleConfirmAuthSelection}
          onCancel={() => setShowAuthPopup(false)}
          selectionMode="multiple"
          targetType="all"
          initialSelected={auths || []}
        />
      )}

    </div>
  );
}

export default AprvDocView;
